import { render, staticRenderFns } from "./AlarmsComponent.vue?vue&type=template&id=5d21857b"
import script from "./AlarmsComponent.vue?vue&type=script&lang=js"
export * from "./AlarmsComponent.vue?vue&type=script&lang=js"
import style0 from "./AlarmsComponent.vue?vue&type=style&index=0&id=5d21857b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports